import { css } from 'lit';
import { denormalize } from 'normalizr';
import { EditUserDto, PermissionGroupType, RoleWithUsersDto } from '../../../typings/api';
import { RootState } from '../redux-store';
import { rolesSchema } from '../../schemas';

export const rolesWithUsersSelector = (state: RootState): RoleWithUsersDto[] =>
	denormalize(
		state.userManagement.roleIds,
		[rolesSchema],
		state.userManagement.entities,
	) as RoleWithUsersDto[];

export const roleSelector = (state: RootState, roleId: number): RoleWithUsersDto =>
	denormalize(roleId, rolesSchema, state.userManagement.entities) as RoleWithUsersDto;

export const userSelector = (state: RootState, userId: number): EditUserDto =>
	state.userManagement.entities.users[userId];

export const permissionGroupsSelector = (state: RootState): PermissionGroupType[] =>
	state.userManagement.permissionGroups;

export const existsUsernameSelector = (
	state: RootState,
	username: string,
	existingUserId?: number | null,
): boolean => {
	return !!Object.values(state.userManagement.entities.users).find((user) => {
		if (
			(user.username === username || user.email === username) &&
			(!existingUserId || user.id !== existingUserId)
		) {
			return true;
		}
		return false;
	});
};
